"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDuration = isDuration;
/**
 * Determine if the request slot value is a Duration
 *
 * @public
 * @param slotValue - Slot value to check
 */
function isDuration(slotValue) {
    return !!slotValue && typeof slotValue === "object" && typeof slotValue.amount === "number" && typeof slotValue.format === "string";
}
//# sourceMappingURL=isDuration.js.map